<template>
    <div class="order-order order-step">
        <div class="order-step__title order-order__title">Оформление заказа</div>
        <form @submit.prevent="nextStep" class="form order-order__form">
            <div class="order-order__ordering" :class="{addPadding : orderListWarning || showDisclaimerWeekend}">
                <div class="order-order__ordering-patient">
                    <div class="form__row form__row__name">
                        <div :class="['form__field order-order__ordering-data', { focused: orderInfo.surname, error: $v.orderInfo.surname.$error}]">
                            <div class="form__field-wrapper">
                                <div class="form__field-label">Фамилия</div>
                                <input @blur="$v.orderInfo.surname.$touch()" type="text" v-focus v-model.trim="orderInfo.surname" />
                            </div>
                            <div class="error" v-if="!$v.orderInfo.surname.required">Обязательное поле</div>
                            <div class="error" v-if="!$v.orderInfo.surname.isCorrect">Только русские буквы</div>
                        </div>
                        <div :class="['form__field order-order__ordering-data', { focused: orderInfo.name, error: $v.orderInfo.name.$error }]">
                            <div class="form__field-wrapper">
                                <div class="form__field-label">Имя</div>
                                <input @blur="$v.orderInfo.name.$touch()" type="text" v-focus v-model.trim="orderInfo.name" />
                            </div>
                            <div class="error" v-if="!$v.orderInfo.name.required">Обязательное поле</div>
                            <div class="error" v-if="!$v.orderInfo.name.isCorrect">Только русские буквы</div>
                        </div>
                        <div
                             :class="[
                                 'form__field order-order__ordering-data', {
                                 focused: orderInfo.patronymic,
                                 error: $v.orderInfo.patronymic.$error,
                                 disabled: isPatronymicCheckbox
                             }]"
                        >
                            <div class="form__field-wrapper">
                                <div class="form__field-label">Отчество</div>
                                <input @blur="$v.orderInfo.patronymic.$touch()" type="text" v-focus v-model.trim="orderInfo.patronymic" />
                            </div>
                            <div class="error" v-if="!$v.orderInfo.patronymic.required">Обязательное поле</div>
                            <div class="error" v-if="!$v.orderInfo.patronymic.isCorrect">Только русские буквы</div>
                        </div>
                        <div :class="['form__field order-order__ordering-data', { focused: orderInfo.birth, error: $v.orderInfo.birth.$error }]">
                            <div class="form__field-wrapper">
                                <div class="form__field-label">Дата рождения</div>
                                <!-- <input @change="modalTouchDateOfBirth" @input="$v.orderInfo.birth.$touch(); dateInput()" name="birth" type="text" v-focus v-if="!isIE && !isFirefox" v-input-mask="'date'" v-model="orderInfo.birth" /> -->
                                <masked-input type="text" mask="11.11.1111" v-model="orderInfo.birth" @blur.native="$v.orderInfo.birth.$touch()" />
                            </div>
                            <div class="error" v-if="!$v.orderInfo.birth.required">Обязательное поле</div>
                            <div class="error" v-else-if="!$v.orderInfo.birth.isDate || !$v.orderInfo.birth.maxDate || !$v.orderInfo.birth.isCorrectDate">Некорректная дата</div>
                        </div>
                    </div>
                    <div class="form__row-col order-order__checkbox-wrapper">
                        <div class="form__row-col order-order__ispatronymic">
                            <div class="form__field form__field-checkbox">
                                <div v-if="!isIE" class="checkbox">
                                    <input @click="patronymicChange" id="isPatronymicCheckbox" type="checkbox" v-model="isPatronymicCheckbox" />
                                    <label for="isPatronymicCheckbox"><span class="checkbox-icon"></span><span class="checkbox-text">Нет отчества</span></label>
                                </div>
                                <div v-else class="checkbox" @click="patronymicChange">
                                    <input id="isPatronymicCheckbox" type="checkbox" v-model="isPatronymicCheckbox" />
                                    <label for="isPatronymicCheckbox"><span class="checkbox-icon"></span><span class="checkbox-text">Нет отчества</span></label>
                                </div>
                            </div>
                        </div>
                        <div class="form__row-col order-order__gender-wrapper">
                            <div class="form__row-col order-order__gender">
                                <div class="order-order__gender-title">Пол:</div>
                                <div class="form__field form__field-checkbox">
                                    <div class="checkbox">
                                        <input :value="'M'" @change="$v.orderInfo.gender.$touch()" id="gender-male" type="radio" v-model="orderInfo.gender" />
                                        <label for="gender-male"><span class="checkbox-icon"></span><span class="checkbox-text">Мужской</span></label>
                                    </div>
                                </div>
                                <div class="form__field form__field-checkbox">
                                    <div class="checkbox">
                                        <input :value="'F'" @change="$v.orderInfo.gender.$touch()" id="gender-female" type="radio" v-model="orderInfo.gender" />
                                        <label for="gender-female"><span class="checkbox-icon"></span><span class="checkbox-text">Женский</span></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form__row-col form__row-col-data">
                        <div :class="['form__field order-order__ordering-data', { focused: orderInfo.phone, error: $v.orderInfo.phone.$error }]">
                            <div class="form__field-wrapper">
                                <div class="form__field-label">Телефон</div>
                                <input
                                    type="tel"
                                    inputmode="tel"
                                    v-model="orderInfo.phone"
                                    id="payer-phone"
                                    v-mask="'phone'"
                                    @input="$v.orderInfo.phone.$touch()" 
                                    @change="modalTouchPayer"
                                    autocomplete="tel"
                                    ref="payer-phone"
                                    v-focus
                                />
                                <!-- <masked-input type="text" mask="\+\7 111 111 11 11" v-model="orderInfo.phone" @blur.native="$v.orderInfo.phone.$touch()" /> -->
                            </div>
                            <div class="error" v-if="!$v.orderInfo.phone.required">Обязательное поле</div>
                            <div class="error" v-if="orderInfo.phone.length&&!$v.orderInfo.phone.isCorrect">Некорректный номер</div>
                        </div>
                        <div :class="['form__field order-order__ordering-data', { focused: orderInfo.email, error: $v.orderInfo.email.$error }]">
                            <div class="form__field-wrapper">
                                <div class="form__field-label">E-mail</div>
                                <input @blur="$v.orderInfo.email.$touch()" type="text" v-focus v-model.trim="orderInfo.email" />
                            </div>
                            <div class="error" v-if="!$v.orderInfo.email.required">Обязательное поле</div>
                            <div class="error" v-if="!$v.orderInfo.email.email">Некорректный E-mail</div>
                        </div>
                    </div>
                    <div class="form__row-col order-order__ispatient">
                        <div class="form__field form__field-checkbox">
                            <div class="checkbox">
                                <input type="checkbox" id="isPatient" v-model="orderInfo.isPatient">
                                <label for="isPatient"><span class="checkbox-icon"></span><span class="checkbox-text">Плательщик является пациентом</span></label>
                            </div>
                        </div>
                    </div>
                    <div v-if="!orderInfo.isPatient">
                        <div class="form__row form__row__name">
                            <div :class="['form__field order-order__ordering-data', { focused: orderInfo.surnamePatient, error: $v.orderInfo.surnamePatient.$error }]">
                                <div class="form__field-wrapper">
                                    <div class="form__field-label">Фамилия пациента</div>
                                    <input @blur="$v.orderInfo.surnamePatient.$touch()" type="text" v-focus v-model.trim="orderInfo.surnamePatient" />
                                </div>
                                <div class="error" v-if="!$v.orderInfo.surnamePatient.required">Обязательное поле</div>
                                <div class="error" v-if="orderInfo.surnamePatient.length && !$v.orderInfo.surnamePatient.isCorrect">Только русские буквы</div>
                            </div>
                            <div :class="['form__field order-order__ordering-data', { focused: orderInfo.namePatient, error: $v.orderInfo.namePatient.$error }]">
                                <div class="form__field-wrapper">
                                    <div class="form__field-label">Имя пациента</div>
                                    <input @blur="$v.orderInfo.namePatient.$touch()" type="text" v-focus v-model.trim="orderInfo.namePatient" />
                                </div>
                                <div class="error" v-if="!$v.orderInfo.namePatient.required">Обязательное поле</div>
                                <div class="error" v-if="orderInfo.namePatient.length&&!$v.orderInfo.namePatient.isCorrect">Только русские буквы</div>
                            </div>
                            <div
                                :class="[
                                    'form__field order-order__ordering-data', {
                                    focused: orderInfo.patronymicPatient,
                                    error: $v.orderInfo.patronymicPatient.$error,
                                    disabled: isPatronymicPatientCheckbox
                                }]"
                            >
                                <div class="form__field-wrapper">
                                    <div class="form__field-label">Отчество пациента</div>
                                    <input @blur="$v.orderInfo.patronymicPatient.$touch()" type="text" v-focus v-model.trim="orderInfo.patronymicPatient" />
                                </div>
                                <div class="error" v-if="!$v.orderInfo.patronymicPatient.required">Обязательное поле</div>
                                <div class="error" v-if="orderInfo.patronymicPatient.length&&!$v.orderInfo.patronymicPatient.isCorrect">Только русские буквы</div>
                            </div>
                            <div :class="['form__field order-order__ordering-data', { focused: orderInfo.birthPatient, error: $v.orderInfo.birthPatient.$error }]">
                                <div class="form__field-wrapper">
                                    <div class="form__field-label">Дата рождения</div>
                                    <!-- <input
                                        @input="$v.orderInfo.birthPatient.$touch(); dateInput()"
                                        @change="modalTouchDateOfBirthPatient"
                                        name="birthday"
                                        type="text"
                                        v-focus
                                        v-if="!isIE && !isFirefox"
                                        v-input-mask="'date'"
                                        v-model="orderInfo.birthPatient"
                                    /> -->
                                    <masked-input type="text" mask="11.11.1111"  v-focus v-model="orderInfo.birthPatient" @blur.native="$v.orderInfo.birthPatient.$touch()" />
                                </div>
                                <div class="error" v-if="!$v.orderInfo.birthPatient.required">Обязательное поле</div>
                                <div class="error" v-else-if="!$v.orderInfo.birthPatient.isDate || !$v.orderInfo.birthPatient.maxDate || !$v.orderInfo.birthPatient.isCorrectDate">Некорректная дата</div>
                            </div>
                        </div>
                        <div class="form__row-col order-order__checkbox-wrapper">
                            <div class="form__row-col order-order__ispatronymic">
                                <div class="form__field form__field-checkbox">
                                    <div v-if="!isIE" class="checkbox">
                                        <input
                                            @click="patronymicPatientChange"
                                            id="isPatronymicPatientCheckbox"
                                            type="checkbox"
                                            v-model="isPatronymicPatientCheckbox"
                                        />
                                        <label for="isPatronymicPatientCheckbox"><span class="checkbox-icon"></span><span class="checkbox-text">Нет отчества</span></label>
                                    </div>
                                    <div v-else class="checkbox" @click="patronymicPatientChange">
                                        <input
                                            id="isPatronymicPatientCheckbox"
                                            type="checkbox"
                                            v-model="isPatronymicPatientCheckbox"
                                        />
                                        <label for="isPatronymicPatientCheckbox"><span class="checkbox-icon"></span><span class="checkbox-text">Нет отчества</span></label>
                                    </div>
                                </div>
                            </div>
                            <div class="form__row-col order-order__gender-wrapper">
                                <div class="form__row-col order-order__gender">
                                    <div class="order-order__gender-title">Пол:</div>
                                    <div class="form__field form__field-checkbox">
                                        <div class="checkbox">
                                            <input
                                                :value="'M'"
                                                @change="$v.orderInfo.genderPatient.$touch()"
                                                id="genderPatient-male"
                                                type="radio"
                                                v-model="orderInfo.genderPatient"
                                            />
                                            <label for="genderPatient-male"><span class="checkbox-icon"></span><span class="checkbox-text">Мужской</span></label>
                                        </div>
                                    </div>
                                    <div class="form__field form__field-checkbox">
                                        <div class="checkbox">
                                            <input
                                                :value="'F'"
                                                @change="$v.orderInfo.genderPatient.$touch()"
                                                id="genderPatient-female"
                                                type="radio"
                                                v-model="orderInfo.genderPatient"
                                            />
                                            <label for="genderPatient-female"><span class="checkbox-icon"></span><span class="checkbox-text">Женский</span></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form__row-col form__row-col-data">
                            <div class="form__field order-order__ordering-data"
                                    :class="{focused: orderInfo.phonePatient, error: $v.orderInfo.phonePatient.$error}">
                                <div class="form__field-wrapper">
                                    <div class="form__field-label">Телефон</div>
                                    <input
                                        type="tel"
                                        inputmode="tel"
                                        v-model="orderInfo.phonePatient"
                                        id="patient-phone"
                                        v-mask="'phone'"
                                        @input="$v.orderInfo.phonePatient.$touch()" 
                                        @change="modalTouchPatient"
                                        autocomplete="tel"
                                        ref="patient-phone"
                                        v-focus
                                    />
                                    <!-- <masked-input type="text" mask="\+\7 111 111 11 11" v-model="orderInfo.phonePatient" @blur.native="$v.orderInfo.phonePatient.$touch()" /> -->

                                </div>
                                <div class="error" v-if="!$v.orderInfo.phonePatient.required">Обязательное поле</div>
                                <div class="error" v-if="orderInfo.phonePatient.length&&!$v.orderInfo.phonePatient.isCorrect">
                                    Некорректный номер
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="order-order__ordering-info" v-if="mode=='pnd'">
                    <div class="form__row" :class="{disabled: slotStatusPreloader}">
                        <div class="form__row-col order-order__ordering-receiptdate">
                            <div class="form__field">
                                <div class="form__label">Дата приема</div>
                                <div class="form__field-wrapper form__field-wrapper_date-select">
                                    <select-date
                                        :is-available-today="isAvailableToday"
                                        :max-dates="2"
                                        :order-time-limit="orderTimeLimit"
                                        v-model="orderInfo.receiptDate"
                                        @change="updDate(true)"
                                        @input="updDate(true)"
                                    />
                                </div>
                                <div v-if="slotStatusPreloader" class="form__field-wrapper-loader">
                                    <svg version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                        viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">
                                            <path fill="#4CA8A9" d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
                                            <animateTransform
                                                attributeName="transform"
                                                attributeType="XML"
                                                type="rotate"
                                                dur="1s"
                                                from="0 50 50"
                                                to="360 50 50"
                                                repeatCount="indefinite" />
                                        </path>
                                        </svg>
                                </div>
                                <div class="order-order__order-list-warning" v-html="disclaimerUnavailableToday" v-if="!isAvailableToday" />
                            </div>
                        </div>
<!--                        <div class="form__row-col order-order__ordering-receiptdate">-->
<!--                            <div class="form__field order-order__ordering-data __select-date-field">-->
<!--                                <div class="form__label">Время приема</div>-->
<!--                                    <div class="__select-container">-->
<!--										<FormSelect-->
<!--											:data-array="[-->
<!--                                        '08:00-11:00',-->
<!--                                        '09:00-12:00',-->
<!--                                        '10:00-13:00',-->
<!--                                        '11:00-14:00',-->
<!--                                        '12:00-15:00',-->
<!--                                        '13:00-16:00',-->
<!--                                        '14:00-17:00',-->
<!--                                        '15:00-18:00',-->
<!--                                        '16:00-19:00',-->
<!--                                        '17:00-20:00',-->
<!--                                        '18:00-21:00',-->
<!--                                        '19:00-22:00',-->
<!--                                        '20:00-23:00',-->
<!--                                        '21:00-00:00',-->
<!--                                        '22:00-01:00',-->
<!--                                        '23:00-02:00',-->
<!--                                        '00:00-03:00',-->
<!--                                        '01:00-04:00',-->
<!--                                        '02:00-05:00',-->
<!--                                        '03:00-06:00',-->
<!--                                        '04:00-07:00',-->
<!--                                        '05:00-08:00',-->
<!--                                        '06:00-09:00',-->
<!--                                        '07:00-10:00'-->
<!--                                    ]"-->
<!--											placeholder="Время приезда"-->
<!--											v-model="orderInfo.receiptTime"-->
<!--											:value="orderInfo.receiptTime"-->
<!--											@change="updDate(false)"-->
<!--										/>-->
<!--										<span-->
<!--											v-if="orderInfo.receiptTime"-->
<!--											class="order-order__unselect-time"-->
<!--											@click="orderInfo.receiptTime = null"-->
<!--										></span>-->
<!--									</div>-->
<!--                            </div>-->
<!--                        </div>-->
                    </div>
                    <div class="form__row">
                        <div class="form__row-col order-order__ordering-appointment">
                            <div class="form__field">
                                <div class="form__label">Врачебное назначение</div>
                                <div class="form__field-wrapper form__field-wrapper_file-load">
                                    <file-input
                                        v-model="orderInfo.file"
                                        :fileAccept="[
                                            'text/plain',
                                            'application/pdf',
                                            'application/msword',
                                            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                                            'image/jpeg',
                                            'image/png'
                                        ]"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="order-services__buttons">
                    <button
                        :disabled="$v.$invalid || !orderInfo.conditions || !isAgree || slotStatus !== '' || slotStatusPreloader"
                        class="button button_dark"
                        type="submit"
                    >{{ btnText }}</button>
                </div>
                <div class="checkbox order-order__conditions">
                    <input id="conditions" name="conditions" type="checkbox" v-model="isAgree" />
                    <label for="conditions">
                        <span>
                            <span :style="[!isAgree && !$v.$invalid ? {'border-color': '#ff0000'} : {'border-color': '#EAEAEA'}]" class="checkbox-icon"></span>Я согласен с условиями <a href="/document_politics.php" target="_blank">Политики обработки персональных данных</a> и <a href="https://medsi.ru/document.php?element=1284544" target="_blank">офертой</a>, и даю <a href="/document.php?element=103802617" target="_blank">Согласие на обработку моих персональных данных</a>
                        </span>
                    </label>
                </div>
                <div class="checkboxError" v-if="!isAgree && !$v.$invalid">Обязательное поле</div>
                <!-- <div class="agreement_and_docs">
                    <div class="agreement_and_docs_text">* Нажимая кнопку «{{ btnText }}», вы соглашаетесь с обработкой своих персональных данных АО «Группа компаний «МЕДСИ»</div>
                    <div class="agreement_and_docs_docs">
                        <div>
                            <a class="agreement_and_docs_links" href="/document_politics.php" target="_blank">Политика в отношении обработки персональных данных</a>
                        </div>
                        <div>
                            <a class="agreement_and_docs_links" href="/document_agreement.php" target="_blank">Согласие на обработку персональных данных</a>
                        </div>
                    </div>
                </div> -->
            </div>
            <div class="order-services__order-shadow" v-if="orderOpened" />
        </form>
    </div>
</template>

<script>
    // Count не используется
    // import Count from './Count';
    import {ru} from 'vuejs-datepicker/dist/locale'
    import Sticky from 'vue-sticky-directive';
    import FileInput from './FileInput';
    import SelectDate from './SelectDate';
    import {required, requiredIf, email} from 'vuelidate/lib/validators';
    import {disablePageScroll, enablePageScroll} from 'scroll-lock';
    import MaskedInput from 'vue-masked-input';
    import moment from 'moment';
    import 'moment/locale/ru';

    moment.locale('ru');
    // vueCustomScrollbar не используется
    // import vueCustomScrollbar from 'vue-custom-scrollbar'
    import "vue-custom-scrollbar/dist/vueScrollbar.css"
    import axios from 'axios';
    // import FormSelect from './FormSelect';

    export default {
        name: 'OrderRegistration',
        props: {
            order: {
                type: Array,
                default: () => [],
            },
            orderTemp: {
                type: Array,
                default: () => [],
            },
            mode: {
                type: String,
                default: 'pnd',
            },
            orderInfo: {
                surname: '',
                name: '',
                patronymic: '',
                fio: '',
                gender: '',
                surnamePatient: '',
                namePatient: '',
                patronymicPatient: '',
                fioPatient: '',
                genderPatient: '',
                birth: '',
                birthPatient: '',
                phone: '',
                phonePatient: '',
                email: '',
                isPatient: true,
                receiptDate: '',
                receiptTime: '',
                file: [],
                conditions: true,
            },
            nurse: {
                type: Object,
            },
            showDisclaimerWeekend: {
                type: Boolean,
                default: false
            },
            orderTimeLimit: {
                type: Array,
                default() {
                    return []
                }
            },
            slotStatusPreloader: {
                type: Boolean
            },
            slotStatus: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                orderServices: [],
                ru: ru,
                isDesktop: window.matchMedia('(min-width: 1025px)').matches,
                orderOpened: false,
                // vueCustomScrollbar не используется
                // scrollBarSettings: {
                //     suppressScrollY: false,
                //     suppressScrollX: false,
                //     wheelPropagation: false,
                //     wheelSpeed: 0.3,
                // },
                isAgree: false,
                orderListWarning: null,
                orderListWarningTimeout: null,
                isPatronymicCheckbox: false,
                isPatronymicPatientCheckbox: false,
                isIE: false,
                acitonsArr: [],
                isOdd: window.innerHeight %2,
                isFirefox: navigator.userAgent.toLowerCase().includes('firefox'),
                date: new Date(),
          }
        },
        validations() {
            if (!this.orderInfo.isPatient) {
                return {
                    orderInfo: {
                        surname: {
                            required,
                            isCorrect: (param) => {
                                // eslint-disable-next-line no-useless-escape
                                return param ? /^[А-Яа-яЁё]([А-Яа-яЁё  \-]+)?$/.test(param) : true;
                            },
                        },
                        name: {
                            required,
                            isCorrect: (param) => {
                                // eslint-disable-next-line no-useless-escape
                                return param ? /^[А-Яа-яЁё]([А-Яа-яЁё  \-]+)?$/.test(param) : true;
                            },
                        },
                        patronymic: {
                            required: requiredIf(()=>!this.isPatronymicCheckbox),
                            isCorrect: (param) => {
                                // eslint-disable-next-line no-useless-escape
                                return param ? /^[А-Яа-яЁё]([А-Яа-яЁё  \-]+)?$/.test(param) : true;
                            },
                        },
                        gender: {
                            required,
                        },
                        phone: {
                            required,
                            isCorrect: (param) => {
                                // eslint-disable-next-line no-useless-escape
                                return param ? !/_/.test(param) : true;
                            },
                        },
                        email: {
                            required,
                            email,
                        },
                        birth: {
                            required,
                            isDate: (param) => {
                                return param ? moment(param, 'DD.MM.YYYY', true).isValid() : true;
                            },
                            maxDate: (param) => {
                                return param ? moment(param, 'DD.MM.YYYY', true).isBefore(new Date()) : true;
                            },
                            isCorrectDate: (param) => {
                                let paramReverse = param.split('.').reverse();
                                let currentValueDateTime = new Date(paramReverse[0], paramReverse[1] - 1, paramReverse[2])
                                return param.length &&
                                    moment(param, 'DD.MM.YYYY', true).isValid() &&
                                    currentValueDateTime.getTime() > new Date(1800, 0, 1).getTime() &&
                                    currentValueDateTime.getTime() <= new Date().getTime() &&
                                    param.split('.')[2][0] != '0';
                            }
                        },
                        surnamePatient: {
                            required,
                            isCorrect: (param) => {
                                // eslint-disable-next-line no-useless-escape
                                return param ? /^[А-Яа-яЁё]([А-Яа-яЁё  \-]+)?$/.test(param) : true;
                            },
                        },
                        namePatient: {
                            required,
                            isCorrect: (param) => {
                                // eslint-disable-next-line no-useless-escape
                                return param ? /^[А-Яа-яЁё]([А-Яа-яЁё  \-]+)?$/.test(param) : true;
                            },
                        },
                        patronymicPatient: {
                            required: requiredIf(()=>!this.isPatronymicPatientCheckbox),
                            isCorrect: (param) => {
                                // eslint-disable-next-line no-useless-escape
                                return param ? /^[А-Яа-яЁё]([А-Яа-яЁё  \-]+)?$/.test(param) : true;
                            },
                        },
                        genderPatient: {
                            required,
                        },
                        birthPatient: {
                            required,
                            isDate: (param) => {
                                return param ? moment(param, 'DD.MM.YYYY', true).isValid() : true;
                            },
                            maxDate: (param) => {
                                return param ? moment(param, 'DD.MM.YYYY', true).isBefore(new Date()) : true;
                            },
                            isCorrectDate: (param) => {
                                let paramReverse = param.split('.').reverse();
                                let currentValueDateTime = new Date(paramReverse[0], paramReverse[1] - 1, paramReverse[2])
                                return param.length &&
                                    moment(param, 'DD.MM.YYYY', true).isValid() &&
                                    currentValueDateTime.getTime() > new Date(1800, 0, 1).getTime() &&
                                    currentValueDateTime.getTime() <= new Date().getTime() &&
                                    param.split('.')[2][0] != '0';
                            }
                        },
                        phonePatient: {
                            required,
                            isCorrect: (param) => {
                                // eslint-disable-next-line no-useless-escape
                                return param ? !/_/.test(param) : true;
                            },
                        },
                    },
                }
            } else {
                return {
                    orderInfo: {
                        surname: {
                            required,
                            isCorrect: (param) => {
                                // eslint-disable-next-line no-useless-escape
                                return param ? /^[А-Яа-яЁё]([А-Яа-яЁё  \-]+)?$/.test(param) : true;
                            },
                        },
                        name: {
                            required,
                            isCorrect: (param) => {
                                // eslint-disable-next-line no-useless-escape
                                return param ? /^[А-Яа-яЁё]([А-Яа-яЁё  \-]+)?$/.test(param) : true;
                            },
                        },
                        patronymic: {
                            required: requiredIf(()=>!this.isPatronymicCheckbox),
                            isCorrect: (param) => {
                                // eslint-disable-next-line no-useless-escape
                                return param ? /^[А-Яа-яЁё]([А-Яа-яЁё  \-]+)?$/.test(param) : true;
                            },
                        },
                        gender: {
                            required,
                        },
                        phone: {
                            required,
                            isCorrect: (param) => {
                                // eslint-disable-next-line no-useless-escape
                                return param ? !/_/.test(param) : true;
                            },
                        },
                        email: {
                            required,
                            email,
                        },
                        birth: {
                            required,
                            isDate: (param) => {
                                return param ? moment(param, 'DD.MM.YYYY', true).isValid() : true;
                            },
                            maxDate: (param) => {
                                return param ? moment(param, 'DD.MM.YYYY', true).isBefore(new Date()) : true;
                            },
                            isCorrectDate: (param) => {
                                let paramReverse = param.split('.').reverse();
                                let currentValueDateTime = new Date(paramReverse[0], paramReverse[1] - 1, paramReverse[2])
                                return param.length &&
                                    moment(param, 'DD.MM.YYYY', true).isValid() &&
                                    currentValueDateTime.getTime() > new Date(1800, 0, 1).getTime() &&
                                    currentValueDateTime.getTime() <= new Date().getTime() &&
                                    param.split('.')[2][0] != '0';
                            }
                        },
                    },
                }
            }
        },
        methods: {
            patronymicChange(){
                this.isPatronymicCheckbox = !this.isPatronymicCheckbox;
                this.orderInfo.patronymic = '';
            },
            patronymicPatientChange(){
                this.isPatronymicPatientCheckbox = !this.isPatronymicPatientCheckbox;
                this.orderInfo.patronymicPatient = '';
            },
            nextStep() {
                this.$v.$touch();
                this.$emit('next');
                window.scrollTo(0, 0);
            },
            updDate(date = false) {
                date ? this.$emit('checkSlot', this.date) : '';
                this.$emit('updateTime', {date: this.date, time: this.time});
            },
            removeService(item) {
                let list = this.orderServices;
                const isAutoNurse = item.auto;

                if (item.servicesWeekIds && item.servicesWeekIds.length) {
                    item.servicesWeekIds.forEach(id => {
                        list = this._remove(list, id, isAutoNurse);
                    });
                } else {
                    list = this._remove(list, item.id, isAutoNurse);
                }
                this.orderServices = list;

                setTimeout(()=>{
                    this.checkActions();
                },500)
            },
            _remove(list, id, isAutoNurse) {
                if (!isAutoNurse) {
                    list = list.filter(x => x.id !== id);
                } else {
                    if (list.length === 1) {
                        list = list.filter(x => x.id !== id);
                    } else {
                        this.orderListWarning = 'В корзине присутствуют медицинские манипуляции, которые должна выполнять медсестра или врач.';

                        if (this.orderListWarningTimeout) {
                            clearTimeout(this.orderListWarningTimeout);
                        }

                        this.orderListWarningTimeout = setTimeout(() => {
                            clearTimeout(this.orderListWarningTimeout);
                            this.orderListWarningTimeout = null;
                            this.orderListWarning = null;
                        }, 5000);
                    }
                }
                return list;
            },
            syncQuantity(checked, id, num) {
                if (checked) {
                    this.orderServices.find(x => x.id === id).num = num;
                }
            },
            checkZero(id, num) {
                if (!num) {
                    this.orderServices = this.orderServices.filter(x => x.id !== id);
                }
            },
            customFormatter(date) {
                const diff = moment(0, "HH").diff(date, "days");
                if (diff == 0) {
                    return moment(date).format('[сегодня,] DD MMMM');
                } else if (diff == -1) {
                    return moment(date).format('[завтра,] DD MMMM');
                }
                return moment(date).format('dddd, DD MMMM');
            },
            viewOrder() {
                this.orderOpened = !this.orderOpened;

                const siteScrollTop = document.documentElement.scrollTop;
                const screenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
                const footerEl = document.getElementById('footer');
                const {top} = footerEl.getBoundingClientRect();
                const footerTop = top + siteScrollTop - screenHeight;

                if (this.orderOpened && (siteScrollTop > footerTop)) {
                    this.$scrollTo(document.documentElement, 300, {
                        offset: footerTop,
                        force: true,
                        cancelable: false,
                        onDone: disablePageScroll,
                    });
                } else {
                    this.orderOpened ? disablePageScroll() : enablePageScroll();
                }
            },
            getAutoType(item) {
                return item.autoType || (item.auto ? 'nurse' : null);
            },
            isAutoType(item, type) {
                return item.auto && this.getAutoType(item) === type;
            },
            removeAutoType(type) {
                this.orderServices = this.orderServices.filter(x => !(x.auto && this.getAutoType(x) === type));
            },
            replaceNurse(baby = false) {
                let nurseExist = this.orderServices.find(x => this.isAutoType(x, 'nurse'));
                let uziNurseExist = this.orderServices.find(x => this.isAutoType(x, 'uzi'));
                if (nurseExist) {
                    this.removeAutoType('nurse');
                    if (!baby && this.nurse.adults) {
                        this.nurse.adults.auto = true;
                        this.nurse.adults.autoType = 'nurse';
                        this.orderServices.push(this.nurse.adults)
                    } else if (baby && this.nurse.children) {
                        this.nurse.children.auto = true;
                        this.nurse.children.autoType = 'nurse';
                        this.orderServices.push(this.nurse.children)
                    }
                }
                if (uziNurseExist) {
                    this.removeAutoType('uzi');
                    if (!baby && this.nurse.adults_uzi) {
                        this.nurse.adults_uzi.auto = true;
                        this.nurse.adults_uzi.autoType = 'uzi';
                        this.orderServices.push(this.nurse.adults_uzi)
                    } else if (baby && this.nurse.children_uzi) {
                        this.nurse.children_uzi.auto = true;
                        this.nurse.children_uzi.autoType = 'uzi';
                        this.orderServices.push(this.nurse.children_uzi)
                    }
                }
            },
            dateInput() {
                const patientBirth = this.orderInfo.isPatient ? 'birth' : 'birthPatient';
                if (!this.$v.orderInfo[patientBirth].$error) {
                    this.replaceNurse(this.isBaby(this.orderInfo[patientBirth]));
                }
            },
            isBaby(date) {
                const castDate = moment(date, 'DD.MM.YYYY');
                let years = moment().diff(castDate, 'years');

                return years < 18
            },

            checkActions() {
                this.acitonsArr = [];

                for(let item of this.order) {
                    if(item.is_price_action) {
                        this.acitonsArr.push(item.title)
                    }
                }
            },

            modalTouchPayer(e) {
                if(this.orderInfo.phone == '') {
                    this.orderInfo.phone = e.target.value;
                }
            },

            modalTouchPatient(e) {
                if(this.orderInfo.phonePatient == '') {
                    this.orderInfo.phonePatient = e.target.value;
                }
            },

            modalTouchDateOfBirth(e) {
                this.orderInfo.birth = e.target.value;
            },

            modalTouchDateOfBirthPatient(e) {
                this.orderInfo.birthPatient = e.target.value;
            }
        },
        components: {
            // Count,
            SelectDate,
            FileInput,
            // FormSelect,
            MaskedInput,
            // vueCustomScrollbar,
        },
        directives: { Sticky },
        watch: {
            orderServices() {
                this.$emit('update:order-temp', this.orderServices);
            },
            'orderInfo.receiptDate'() {
                this.$emit('update:order-date', this.orderInfo.receiptDate);
            }
        },
        computed: {
            disclaimerWeekend() {
                return `Некоторые из услуг предоставляются по выходным по более высокой цене. <b>${moment(this.orderInfo.receiptDate).format('L')}</b> – выходной день. В соответствии с этим произведен перерасчет.`;
            },
            disclaimerUnavailableToday() {
                return `На <b>${moment(new Date()).format('L')}</b> запись закрыта.`;
            },
            total() {
                return this.order.length ? this.order.reduce((acc, obj) => {
                    return acc + Number(obj.price) * obj.num
                }, 0) : 0;
            },
            btnText() {
                return 'Продолжить оформление';
            },
            btnTextShort() {
                return 'Продолжить';
            },
            isAvailableToday() {
                if (!this.orderTimeLimit.length) {
                    return true;
                } else {
                    const currentDate = new Date();
                    const now = currentDate.getHours() * 60 + currentDate.getMinutes();
                    const a = this.orderTimeLimit[0].split(':');
                    const start = Number(a[0]) * 60 + Number(a[1]);
                    const b = this.orderTimeLimit[1].split(':');
                    const end = Number(b[0]) * 60 + Number(b[1]);

                    return start <= now && now < end;
                }
            }
        },
        created() {
            this.checkActions();
            const that = this;
            axios.get('/ajax/getUserInfo.php?axios', {responseType: 'json'}).then(function (response) {
                if (typeof response === 'object') {
                    if (typeof response.data === 'object') {
                        if (response.data.SURNAME.length) {
                            that.orderInfo.surname = response.data.SURNAME;
                        }
                        if (response.data.NAME.length) {
                            that.orderInfo.name = response.data.NAME;
                        }
                        if (response.data.PATRONYMIC.length) {
                            that.orderInfo.patronymic = response.data.PATRONYMIC;
                        }
                        if (response.data.BIRTH.length) {
                            that.orderInfo.birth = response.data.BIRTH;
                        }
                        that.dateInput();
                        if (response.data.PHONE.length) {
                            that.orderInfo.phone = response.data.PHONE;
                        }
                        if (response.data.EMAIL.length) {
                            that.orderInfo.email = response.data.EMAIL;
                        }
                    }
                }
            }).catch(function () {
            });

            if (navigator.userAgent.toLowerCase().includes('rv:11.0') && navigator.userAgent.toLowerCase().includes('trident/7.0')) {
                this.isIE = true
            }
        },
        mounted() {
            this.orderServices = [...this.orderTemp];
            let nurseCount = this.orderServices.find(x => this.isAutoType(x, 'nurse'));

            if (nurseCount && nurseCount.num > 1) {
                if (this.nurse.adults) {
                    this.nurse.adults.enum = true;
                    this.nurse.adults.num = nurseCount.num;
                }
                if (this.nurse.children) {
                    this.nurse.children.enum = true;
                    this.nurse.children.num = nurseCount.num;
                }
            } else {
                if (this.nurse.adults) {
                    this.nurse.adults.enum = false;
                    this.nurse.adults.num = 1;
                }
                if (this.nurse.children) {
                    this.nurse.children.enum = false;
                    this.nurse.children.num = 1;
                }
            }
        },
    }
</script>
<style lang="scss">
    @import "../../scss/base/include";

    .order-order {
        position: relative;
        margin-bottom: 101px !important;
        @include tablet {
            position: static !important;
        }
        @include mobile {
            margin-bottom: 0 !important;
            padding-bottom: 48px !important;
        }

        &::after {
            content: '';
            position: absolute;
            width: 132px;
            height: 115px;
            background: center url(/local/templates/pnd/src/assets/i2/decor.png) no-repeat;
            z-index: -1;
            right: -55px;
            bottom: -50px;
            @include tablet {
                display: none;
            }
        }

        @include mobile {
            .form__row,
            .form__row-col {
                display: block;
                margin-bottom: 10px;
            }
        }

        &__checkbox-wrapper {
            flex-direction: row;
            justify-content: flex-start;
        }

        &__ispatient {
            flex-grow: 1;
            margin-bottom: 20px;
            margin-left: -10px;
        }

        &__ispatronymic {
            width: calc(50% + 25px);
            margin-bottom: 20px;
            margin-left: -10px;
        }

        &__gender-wrapper {
            margin-bottom: 20px;
            @include mobile {
                margin-bottom: 15px;
                margin-top: 15px;
            }
        }

        &__gender {
            align-items: center;

            &-title {
                margin-right: 10px;
            }

            .form__field-checkbox {
                flex: 1 1 auto;
                @include mobile {
                    margin: 10px 0;
                }
            }
        }

		&__unselect-time {
			position: absolute;
			right: 45px;
			top: 48%;
			width: 25px;
			height: 25px;
			cursor: pointer;
			transform: translateY(-50%);

			&:before, &:after {content: ""; position: absolute; top: 50%; width: 24px; height: 2px; background: #979797;}
			&:before {transform: rotate(45deg);}
			&:after {transform: rotate(-45deg);}
		}

        &__form {
            display: flex;
            justify-content: space-between;

            .vue-sticky-placeholder {
                width: 320px;
                float: right;
            }
        }

        &__ordering {
          width: calc(100% - 380px);
          float: left;

          &-data {
            margin: 0 10px 20px;
            width: calc(50% - 20px);
            max-width: calc(50% - 20px);
            flex: 1 1 auto;
          }

          &-data.disabled {
            opacity: 0.5;
            cursor: not-allowed;
          }

          &-data.disabled input {
            pointer-events: none;
          }

          @include tablet {
            padding-bottom: 100px;
            width: 100%;
          }
          @include mobile {
            padding-bottom: 0px;
            &-data {
                width: auto;
                max-width: 100%;
                margin-bottom: 10px;
                }
            }

            &-patient {
                margin-bottom: 55px;

                .checkbox {
                    &-text {
                        display: inline-block;
                    }
                }

                @include tablet {
                    .checkbox {
                        label {
                            font-size: 14px;
                        }

                        &-icon {
                            top: 2px;
                        }

                        &-text {
                            line-height: 17px;
                        }
                    }
                }
                @include mobile {
                    margin-bottom: 35px;

                    .checkbox {
                        label {
                            font-size: 15px;
                        }

                        &-text {
                            line-height: 18px;
                        }
                    }
                }
            }

            &-info {
                margin-bottom: 80px;
                @include mobile {
                    margin-bottom: 33px;
                }

                .form__row-col {
                    @include mobile {
                        width: auto;
                        min-width: 0;
                        max-width: none;
                        .file {
                            height: auto;
                        }
                    }
                }
            }

            &-phone {
                width: 180px;
                max-width: 180px;
                min-width: 180px;
                @include low-desktop {
                    width: 170px;
                    max-width: 170px;
                    min-width: 170px;
                }
                @include mobile {
                    width: auto;
                    max-width: 100%;
                    min-width: 0;
                    margin-bottom: 10px;
                }
            }

            &-mail {
                width: 210px;
                max-width: 210px;
                min-width: 210px;
                @include low-desktop {
                    width: 190px;
                    max-width: 190px;
                    min-width: 190px;
                }
                @include mobile {
                    width: auto;
                    max-width: 100%;
                    min-width: 0;
                    margin-bottom: 10px;
                }
            }

            &-receiptdate {
                flex: 0 0 auto;
                width: 50%;

                @include mobile {
                    width: auto;
                    min-width: 0;
                    margin-bottom: 33px !important;
                }

                .form__field {
                    max-width: 100%;
                    @include mobile {
                        max-width: none;
                    }
                }
            }

            &-appointment {
                flex: 1 1 auto;
                width: 1px;
            }
        }

        &__ordering.addPadding {

            @include tablet {
                padding-bottom: 190px;
            }

            @include mobile {
                padding-bottom: 290px;
            }

        }

        &__title {
            margin-bottom: 47px;
            display: flex;
            align-items: baseline;
            @include tablet {
                margin-bottom: 25px;
            }
            @include mobile {
                margin-bottom: 12px;
            }
        }

        &__order {
            float: right;
            width: 320px !important;
            box-sizing: border-box;
            transform: translate3d(0, 0, 0);

            &-wrapper {
                width: 320px;
                @include tablet {
                    width: auto;
                }
            }

            &-list-scroll {
                margin-right: -20px;
                padding-right: 20px;
                overflow: hidden;
                max-height: 465px;

                @include tablet {
                    margin-right: 0;
                    padding-right: 12px;
                    max-height: 45vh;
                }
            }

            &-list-scroll._isOdd {
                @include tablet {
                    max-height: 44vh;
                }
            }

            @include tablet {
                position: fixed;
                bottom: var(--footer-offset);
                background-color: $white-true;
                width: 100% !important;
                left: 0;
                bottom: 0;
                z-index: 99;
                &.abs {
                    position: absolute;
                }
                &-top {
                    max-height: 0;
                    overflow: hidden;
                    transition: all ease .3s;
                    margin-right: -12px;

                    .opened & {
                        display: block;
                        max-height: 999px;
                        margin-bottom: 17px;
                    }
                }
                &-bottom {
                    display: flex;

                    @include mobile {
                        display: block;
                    }
                }
                &-open {
                    display: block;
                    position: absolute;
                    background: center url(/local/templates/pnd/src/assets/i2/dropdown.svg) no-repeat;
                    height: 11px;
                    width: 16px;
                    transform: rotate(180deg);
                    top: 12px;
                    left: 50%;
                    margin-left: -8px;
                    @include mobile {
                        top: 9px;
                    }

                    .opened & {
                        transform: rotate(0);
                    }
                }
                &.opened {
                    z-index: 100;
                }
            }
            @include mobile {
                &-list {
                    padding-top: 14px;
                    border-top: 1px solid rgba(125, 121, 135, 0.15);
                }
            }

            &-list-warning {
                padding: 0.5em;
                margin: 1em 0;
                border: 1px solid #ffeeba;
                border-radius: 0.25em;
                color: #856404;
                background-color: #fff3cd;
                font-size: 0.9em;

                &:not(:last-child) {
                    margin-bottom: 5px;
                }

                @include mobile {
                    font-size: 0.7em;
                    margin: 0.5em 0;
                }
            }

            &-list-disclaimers {
                margin: 15px 0;

                @include tablet {
                    min-width: 100%;
                }

                @include mobile {
                    margin: 10px 0;
                }
            }

            &-border {
                border: 1px solid rgba(125, 121, 135, 0.2);
                padding: 26px 20px 20px;
                border-radius: 5px;
                @include tablet {
                    box-shadow: 10px -19px 50px rgba(0, 0, 0, 0.12);
                    padding: 26px 60px 20px;
                    border-radius: 0;
                    border: none;
                }
                @include mobile {
                    padding: 12px 12px 35px;
                }
            }

            &-shadow {
                position: fixed;
                z-index: 99;
                background: rgba(125, 121, 135, 0.34);
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            }

            &-title {
                font-weight: 500;
                font-size: 18px;
                line-height: 22px;
                margin-bottom: 24px;
                @include mobile {
                    font-size: 16px;
                    line-height: 20px;
                    margin-bottom: 16px;
                    margin-top: 22px;
                    padding: 0 15px;
                }
            }

            &-item {
                border-bottom: 1px solid rgba(125, 121, 135, 0.15);
                padding-bottom: 23px;
                @include mobile {
                    padding-bottom: 20px;
                }

                &:not(:last-child) {
                    margin-bottom: 27px;
                }

                &-top {
                    display: flex;
                    justify-content: space-between;
                }

                &-price {
                    white-space: nowrap;
                    font-size: 14px;
                    @include mobile {
                        font-size: 16px;
                        line-height: 20px;
                        font-weight: 500;
                    }
                }

                &-name {
                    font-size: 14px;
                    line-height: 18px;
                    padding-right: 20px;
                    @include mobile {
                        font-size: 16px;
                        line-height: 22px;
                    }
                }

                &-close {
                    display: inline-block;
                    width: 8px;
                    height: 8px;
                    background: center url(/local/templates/pnd/src/assets/i2/close.svg) no-repeat;
                    margin-left: 8px;
                    cursor: pointer;
                    @include mobile {
                        margin-left: 4px;
                    }
                }

                &-desc {
                    color: $gray;
                }
            }

            &-total {
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-weight: bold;
                padding: 6px 0 12px;
                margin-top: 23px;
                white-space: nowrap;

                @include tablet {
                    flex: 1;
                    margin-top: 0;
                    padding-top: 12px;
                }
                @include mobile {
                    padding: 0 12px 8px;
                }

                &-label {
                    margin-right: 1em;
                    font-size: 14px;

                    @include mobile {
                        font-size: 14px;
                        line-height: 18px;
                    }
                }

                &-value {
                    font-size: 18px;
                    line-height: 32px;
                    @include mobile {
                        font-size: 14px;
                        line-height: 18px;
                    }
                }
            }

            &-action {
                padding: 0.5em;
                margin: 1em 0;
                border: 1px solid #ffeeba;
                border-radius: 0.25em;
                color: #856404;
                background-color: #fff3cd;
                font-size: 0.9em;

                &__list {
                    font-weight: bold;
                }
            }

            &-btn {
                width: 100%;
                padding: 0px 35px;
                @include tablet {
                    width: 165px;
                    height: 40px;
                    margin-left: 30px;
                    padding: 0px 16px;
                }
                @include mobile {
                    width: 100%;
                    margin-left: 0;
                    height: 35px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 14px;
                }
            }

            &-btn.column {
                @include tablet {
                    margin-left: 0;
                }

            }

            .count {
                margin-top: 13px;
            }
        }

        &__buttons {
            margin-top: 58px;

            .button {
                margin-right: 10px;
            }
        }

        &__conditions {
            margin-top: 20px;
            @include mobile {
                margin-bottom: 50px;
            }

            .checkbox-icon {
                width: 24px;
                height: 24.8px;
                top: 3px;
                background-size: 16px;
                pointer-events: auto;
                @include mobile {
                    top: 0;
                }
            }

            label {
                font-size: 12px;
                line-height: 20px;
                color: $gray;
                pointer-events: none;
                &:hover {
                    color: $gray;
                }

                a {
                    text-decoration: underline;
                    pointer-events: auto;
                    &:hover {
                        color: #00ABAA;
                    }
                }
            }

            @include mobile {
                label {
                    display: flex;
                    align-items: center;
                    min-height: 24px;
                    font-size: 12px;
                    line-height: 14px;
                }
            }
        }

        .form__field {

			&.__select-date-field .__select-container {
				position: relative;
			}

            .form-select__input input {
                padding: 19px 23px;
                background: right 23px center url("/local/templates/pnd/src/assets/i2/select-date.svg") no-repeat;
            }

            .form-select__placeholder {
                left: 23px
            }

            .error {
                position: absolute;
                margin-top: 2px;
                @include mobile {
                    position: static;
                    margin-top: 1px;
                }
            }
        }

    }

    .checkboxError {
        margin-top: 10px;
        font-size: 12px;
        color: rgb(255, 0, 0);
    }

    .form__row__name {
        flex-direction: row;
        flex-wrap: wrap;
        margin-bottom: 0px;
    }

    .form__row-col-data {
        margin: 0 -10px;
    }

    .order-services__order-bottom.column {
        @include tablet {
            flex-direction: column !important;
        }
    }

    .agreement_and_docs {
        margin-top: 10px;
    }

    .form__row.disabled {
        opacity: 0.8;
        pointer-events: none;
    }

    .form__field-wrapper-loader {
        height: 50px;
        width: 100%;
        position: relative;

        svg {
            position: absolute;
            top: 5px;
            left: 40%;
            height: 100%;
        }
    }

</style>
